import { csx, useBreakpoint } from '@vtex/admin-ui'
import React from 'react'

import { SkeletonItem, SkeletonTitle } from '../Skeleton'
import { ProductCarouselPaginatedList } from '../ProductCarouselPaginatedList'

export const CollectionsShelfSkeleton = () => {
  const { breakpoint } = useBreakpoint()

  const itemsPerPage = breakpoint === 'tablet' ? 6 : 4

  return (
    <div
      className={csx({
        display: 'flex',
        flexDirection: 'column',
        gap: '$space-2',
      })}
    >
      <SkeletonTitle />
      <ProductCarouselPaginatedList
        itemsPerPage={itemsPerPage}
        totalCount={itemsPerPage}
        onClickNext={() => {}}
        onClickPrev={() => {}}
      >
        {Array.from({ length: itemsPerPage }).map((_, key) => (
          <SkeletonItem key={key} />
        ))}
      </ProductCarouselPaginatedList>
    </div>
  )
}
